import React from "react";
import { TH } from "./styles";

export const THeader: React.FC = () => {

  return (
    <thead>
      <tr>
        <TH style={{ "minWidth": "250px" }}>Nome</TH>
        <TH>Sexo</TH>
        <TH style={{ "minWidth": "150px" }}>Data de Nascimento</TH>
        <TH style={{ "minWidth": "150px" }}>Grau de Parentesco</TH>
      </tr>
    </thead>
  );
}